import FilePreviewComponent from '@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue';
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';

import {
  get_headers,
  get_token,
  RESPOND_REQUEST_URL,
  VIEW_SINGLE_REQUEST_INFO_URL
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import {
  validate_file
} from '@/utils/validations/validate_inputs';
import axios from 'axios';

export default {
  name: 'UnresolvedRequest',
  mixins: [alert_mixin],
  components: { NavigationBackButton, FilePreviewComponent },

  data: () => ({
    request_note: '',
    is_resolved: '',
    date_requested: '',
    requester_name: '',
    headers: {},
    fields: [],
    request_id: '',
    request_response: {},
    submitted_response: [],
    token: "",
    selected_file: '',
    is_loading: false,
    application_id: null,
    file_validation_error: {},
    preview_modal: false
  }),


  computed: {
    has_submitted_response() {
      return Array.isArray(this.submitted_response)
        && this.submitted_response.length > 0;
    },

    has_rejected_response() {
      return Array.isArray(this.submitted_response)
        && this.submitted_response.some(
          doc => doc.response_rejected === true
        );
    }
  },
  mounted() {
    this.headers = get_headers();
    this.token = get_token();
    this.request_id = this.$route.query.request_id;
    this.application_id = sessionStorage.getItem('application_id')
    this.get_request();
  },

  methods: {

    get_request() {

      axios.get(VIEW_SINGLE_REQUEST_INFO_URL, {
        headers: this.headers,
        params: {
          request_id: parseInt(this.request_id, 10),
        }
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.data.length > 0) {

            var request_info = response_data.data[0];

            this.requester_name = request_info.requested_by_first_name + " " + request_info.requested_by_last_name;
            this.request_note = request_info.message;
            this.is_resolved = request_info.is_resolved;
            this.date_requested = request_info.date_created;

            if (request_info.requested_fields?.length) {
              this.fields = request_info.requested_fields.map(field => ({
                question_id: field.question_id,
                section_question_id: field.requested_field_id,
                label: field.requested_field_text,
                section_id: field.form_section_id,
              }));
            }

            if (request_info.responses?.length) {
              const requested_for_field = request_info.requested_fields || [];
              this.submitted_response = request_info.responses.map(request_response => {
                const matched_field = requested_for_field.find(
                  f => f.question_id === request_response.question_id
                );
                return {
                  document_id: request_response.id,
                  presigned_url: request_response.presigned_url,
                  document_name: matched_field
                    ? matched_field.requested_field_text
                    : "Unknown Document",
                  response_accepted: request_response.response_accepted,
                  response_rejected: request_response.response_rejected,
                  review_status:
                    request_response.response_accepted
                      ? "Approved"
                      : request_response.response_rejected
                        ? "Rejected"
                        : "Pending Review",
                  date_created: request_response.date_created,
                  section_id: request_response.section_id,
                };
              });
            }
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
    },

    open_document(document) {
      this.selected_file = document;
      this.preview_modal = true
    },

    close_the_file_preview() {
      this.preview_modal = false;
      // Optional: reset the selected_url if needed
      this.selected_file = null;
    },


    async handle_file_change(event, index) {
      const file = event.target.files[0];

      if (!file) {
        Reflect.set(this.file_validation_error, index, "No file selected.");
        Reflect.set(this.request_response, index, null);
        return;
      }

      const results = await Promise.resolve(validate_file(file));

      if (!results.valid) {
        Reflect.set(this.file_validation_error, index, results.error);
        Reflect.set(this.request_response, index, null);
        event.target.value = null;
      } else {
        Reflect.set(this.file_validation_error, index, null);
        Reflect.set(this.request_response, index, file);
      }
    },

    submit_response() {
      this.is_loading = true;
      const form_data = new FormData();

      const response_array = []


      Object.entries(this.request_response).forEach(([index, file]) => {
        const field = Object.prototype.hasOwnProperty.call(this.fields, index)
          ? (Reflect.get(this.fields, index) ?? null)
          : undefined;

        const field_dict = {
          [`label`]: field.label,
          [`section_id`]: field.section_id,
          [`question_id`]: field.question_id,
          [`section_question_id`]: field.section_question_id
        };
        response_array.push(field_dict);

        form_data.append(`file_${field.section_id}_${field.question_id}`, file);

        form_data.append("response_array", JSON.stringify(response_array));

      });
      form_data.append("request_id", this.request_id);
      form_data.append("application_id", this.application_id);

      axios.post(RESPOND_REQUEST_URL, form_data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Token ${this.token}`
        }
      })
        .then(response => {
          if (response.data.status === 'success') {
            this.show_success("Response submitted successfully");
          } else {
            this.show_error("Failed to submit response");
          }
        })
        .catch(error => {
          this.show_error('Upload failed:', error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  }
}